export const REGIONS_NAMES = {
  CHIHUAHUA: "Chihuahua",
  CUAUHTEMOC: "Cuauhtémoc",
  DELICIAS: "Delicias",
  PARRAL: "Parral",
  CENTRO_SUR: "Zona centro sur"
}

export const REGIONS_ENUMS = {
  Chihuahua: "CHIHUAHUA",
  "Cuauhtémoc": "CUAUHTEMOC",
  Delicias: "DELICIAS",
  Parral: "PARRAL",
  "Zona centro sur": "CENTRO_SUR"
}

export const ALL_REGIONS = [
  "CHIHUAHUA",
  "CUAUHTEMOC",
  "DELICIAS",
  "PARRAL"
]